import { defaultComposerContainerState } from '#pplx/frontend/composer-sdk/internal/input-state/reducers.js';
import { createContext } from 'react';
export const ComposerContext = createContext({
    state: defaultComposerContainerState,
    dispatch: () => { },
});
ComposerContext.displayName = 'ComposerContext';
//# sourceMappingURL=context.js.map